import React, {Fragment} from "react";
import Card from "../../components/card/Card";
import ModalConfirm from "../../components/ModalConfirm";
import ModalMsg from "../../components/ModalMsg";
import NsScrollableTabs from "../../components/NsScrollableTabs";
import { Dialog } from "primereact/dialog";

export default function ConfClassiTipiImpExpView({
                                                     keyTab,
                                                     translate,
                                                     showConfirm,
                                                     setShowConfirm,
                                                     eliminaClasse,
                                                     classeSel,
                                                     show,
                                                     setShow,
                                                     modalMsg,
                                                     setKeyTab,
                                                     loadingData,
                                                     scrollableTabs,
                                                     bottoniDx,
                                                     elementoDettagli,
                                                     showDettagli,
                                                     setShowDettagli
                                                 }) {

    return (
        <Card
            icon={'fas fa-building'}
            title={'Classi Imp Exp Dati'}
            bottoniDx={bottoniDx}
        >
            <ModalConfirm
                show={showConfirm}
                handleClose={() => setShowConfirm(false)}
                handleOk={eliminaClasse}
                testo={translate("Sicuro di voler eliminare la classe: ") + (classeSel && classeSel.codice) + "?"}/>
            <Dialog
                header={elementoDettagli ? (elementoDettagli.titolo_dettaglio || '') : ''}
                visible={showDettagli}
                style={{width: '50vw'}}
                onHide={() => {
                    setShowDettagli(false)
                }}
            >
                <div className="mn-2">
                    {
                        elementoDettagli && elementoDettagli.testo_dettaglio && typeof elementoDettagli.testo_dettaglio != 'undefined' ?
                            elementoDettagli.testo_dettaglio.split('\n').map((paragraph, index) =>
                                <p key={index}>{paragraph}</p>
                            ) : ''
                    }
                </div>
            </Dialog>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            {
                !loadingData &&
                <Fragment>
                    <NsScrollableTabs
                        activeIndex={keyTab}
                        onTabChange={(e) => setKeyTab(e.index)}
                        scrollableTabs={scrollableTabs}
                    />
                </Fragment>
            }
        </Card>
    );
}
